

import React from 'react';
import { motion } from 'framer-motion';
import '../styles/VerticalParallelSection.css';
import { baseUrl } from '../config';
import Careers from '../assets/img/Careers.png';
import Messaging from '../assets/img/messenging.png';
import { useNavigate } from 'react-router-dom';


const VerticalParallelSection = () => {
  const navigate = useNavigate();

  return (
    <div className="vps">
      <div className="vps__container">
        <div className="vps__content-wrapper">
          {/* Top Section */}
          <motion.div
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: false }}
            transition={{ duration: 1.5, ease: "easeOut" }}
            className="vps__section vps__section--top"
          >
            <div className="vps__card">
              <div className="vps__window-controls">
                <div className="vps__control-dot vps__control-dot--red"></div>
                <div className="vps__control-dot vps__control-dot--yellow"></div>
                <div className="vps__control-dot vps__control-dot--green"></div>
              </div>
              <div className="vps__card-content">
                <div className="vps__content-layout">
                  <div className="vps__image-wrapper">
                    <img
                      src={Messaging}
                      alt="Messaging Feature"
                      className="vps__image"
                    />
                  </div>
                  <div className="vps__text-content">
                    <h2 className="vps__title">Inbuilt Messaging</h2>
                    <p className="vps__description">
                      Connect and collaborate with team members using our integrated messaging platform.
                      Share updates, files, and stay in sync with your colleagues in real-time.
                    </p>
                    <button className="vps__button"
                      onClick={() => navigate('/understandpilo-messenger')}
                    >
                      Learn More  {/* ← add text */}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Bottom Section */}
          <motion.div
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: false }}
            transition={{ duration: 1.5, ease: "easeOut" }}
            className="vps__section vps__section--bottom"
          >
            <div className="vps__card">
              <div className="vps__window-controls">
                <div className="vps__control-dot vps__control-dot--red"></div>
                <div className="vps__control-dot vps__control-dot--yellow"></div>
                <div className="vps__control-dot vps__control-dot--green"></div>
              </div>
              <div className="vps__card-content">
                <div className="vps__content-layout">
                  <div className="vps__image-wrapper">
                    <img
                      src={Careers}
                      alt="Job Roles"
                      className="vps__image"
                    />
                  </div>
                  <div className="vps__text-content">
                    <h2 className="vps__title">Apply to New Roles</h2>
                    <p className="vps__description">
                      Check out directly what are current roles as per real-time movies.
                      We are looking for talented individuals to join our creative team.
                    </p>
                    <button
                      className="vps__button"
                      onClick={() => navigate('/careers')}
                    >
                      Apply Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};


export default VerticalParallelSection;
